export default "__VITE_ASSET__UgKcBrQG__"